module.exports = __webpack_public_path__ + "img/youtube.667fc423.svg";